/* Página /pages/projetos — filtros da galeria + lightbox de projeto (fotos + vídeo
   antes/depois + ficha). Porte de ProjectsGallery + PhotoLightbox do Hydrogen.
   Sem libs. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Filtros */
  var gallery = document.querySelector('[data-sv-proj-gallery]');
  if (gallery) {
    var state = { type: '', line: '' };
    var cells = Array.prototype.slice.call(gallery.querySelectorAll('.sv-proj-cell'));
    gallery.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-sv-filter]');
      if (!chip) return;
      var axis = chip.getAttribute('data-sv-filter');
      state[axis] = chip.getAttribute('data-value') || '';
      // marca ativo na mesma linha
      var row = chip.parentNode;
      row.querySelectorAll('[data-sv-filter]').forEach(function (b) {
        var on = b === chip;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cells.forEach(function (c) {
        var okT = !state.type || c.getAttribute('data-type') === state.type;
        var okL = !state.line || c.getAttribute('data-line') === state.line;
        c.hidden = !(okT && okL);
      });
    });
  }

  /* ---------------------------------------------------------------- Lightbox */
  var lb = document.querySelector('[data-sv-projlb]');
  if (!lb) return;
  var stage = lb.querySelector('[data-sv-plb-stage]');
  var dotsWrap = lb.querySelector('[data-sv-plb-dots]');
  var btnPrev = lb.querySelector('[data-sv-plb-prev]');
  var btnNext = lb.querySelector('[data-sv-plb-next]');
  var elTitle = lb.querySelector('[data-sv-plb-title]');
  var elLoc = lb.querySelector('[data-sv-plb-loc]');
  var elDesc = lb.querySelector('[data-sv-plb-desc]');
  var elFacts = lb.querySelector('[data-sv-plb-facts]');
  var slides = [];
  var idx = 0;
  var lastFocus = null;

  function factRow(label, value) {
    if (!value) return '';
    return '<div><dt>' + label + '</dt><dd>' + escapeHtml(value) + '</dd></div>';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildSlides(data) {
    var out = [];
    if (data.videoBefore || data.videoAfter) {
      out.push({ kind: 'video', before: data.videoBefore, after: data.videoAfter });
    }
    (data.photos || []).forEach(function (url) {
      if (url) out.push({ kind: 'image', url: url });
    });
    return out;
  }

  function renderStage() {
    stage.innerHTML = '';
    var s = slides[idx];
    if (!s) return;
    if (s.kind === 'image') {
      var img = document.createElement('img');
      img.className = 'sv-plb__img';
      img.src = s.url;
      img.alt = elTitle.textContent || 'Foto do projeto';
      stage.appendChild(img);
    } else {
      var wrap = document.createElement('div');
      wrap.className = 'sv-plb__videos';
      if (s.before) wrap.appendChild(videoEl(s.before, 'Antes'));
      if (s.after) wrap.appendChild(videoEl(s.after, 'Depois'));
      stage.appendChild(wrap);
    }
    // dots
    Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
      d.classList.toggle('is-active', i === idx);
      d.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
    var multi = slides.length > 1;
    btnPrev.hidden = !multi;
    btnNext.hidden = !multi;
    dotsWrap.hidden = !multi;
  }

  function videoEl(src, label) {
    var fig = document.createElement('figure');
    fig.className = 'sv-plb__vid';
    var v = document.createElement('video');
    v.src = src;
    v.controls = true;
    v.playsInline = true;
    v.preload = 'metadata';
    fig.appendChild(v);
    var cap = document.createElement('figcaption');
    cap.textContent = label;
    fig.appendChild(cap);
    return fig;
  }

  function go(n) {
    if (!slides.length) return;
    idx = (n + slides.length) % slides.length;
    renderStage();
  }

  function open(data) {
    slides = buildSlides(data);
    idx = 0;
    elTitle.textContent = data.title || 'Projeto';
    if (data.location) { elLoc.textContent = data.location; elLoc.hidden = false; } else { elLoc.hidden = true; }
    if (data.description) { elDesc.textContent = data.description; elDesc.hidden = false; } else { elDesc.hidden = true; }
    elFacts.innerHTML =
      factRow('Produto', data.product) +
      factRow('Linha', data.line) +
      factRow('Piscina', data.poolType) +
      factRow('Arquiteto(a)', data.architect) +
      factRow('Construtor', data.builder);
    // dots
    dotsWrap.innerHTML = '';
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sv-plb__dot';
      b.setAttribute('aria-label', 'Ir para item ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(b);
    });
    renderStage();
    lastFocus = document.activeElement;
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    lb.querySelector('[data-sv-plb-close]').focus();
  }

  function close() {
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    stage.innerHTML = ''; // para os vídeos
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // abrir: clique em qualquer [data-sv-proj-open] → JSON do [data-sv-proj] mais próximo
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-sv-proj-open]');
    if (!trig) return;
    var host = trig.closest('[data-sv-proj]');
    if (!host) return;
    var json = host.querySelector('[data-sv-proj-json]');
    if (!json) return;
    try { open(JSON.parse(json.textContent)); } catch (err) { /* noop */ }
  });

  lb.addEventListener('click', function (e) {
    if (e.target.closest('[data-sv-plb-close]')) close();
  });
  btnPrev.addEventListener('click', function () { go(idx - 1); });
  btnNext.addEventListener('click', function () { go(idx + 1); });

  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(idx - 1);
    else if (e.key === 'ArrowRight') go(idx + 1);
    else if (e.key === 'Tab') {
      var focusable = [].slice.call(lb.querySelectorAll('a[href], button:not([disabled]), video[controls]'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // swipe
  var x0 = null;
  stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
  stage.addEventListener('pointerup', function (e) {
    if (x0 === null) return;
    var dx = e.clientX - x0;
    if (Math.abs(dx) > 60) go(idx + (dx < 0 ? 1 : -1));
    x0 = null;
  });
})();
